import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import axios from "axios";
import reportWebVitals from "./reportWebVitals";

import Root from "./Root";
import { history, store } from "./store";

import { ToastContainer } from "react-toastify";

import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import "react-block-ui/style.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// set the address of server
if (window.location.origin === "http://localhost:3000") {
  axios.defaults.baseURL = "http://127.0.0.1:8000"; // development server address
} else {
  axios.defaults.baseURL = "https://dialmateapi.fly.dev"; // production serevr address
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Root store={store} history={history} />
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={true}
      newestOnTop={true}
      closeOnClick
      pauseOnHover
    />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
